// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes styles_gradientText__6P4Oa {
  0% {
    background-position: 0% 50%; }
  50% {
    background-position: 100% 50%; }
  100% {
    background-position: 0% 50%; } }

.styles_linkContainer__YkRnF {
  width: 75%;
  margin-top: 0.5rem; }
  .styles_linkContainer__YkRnF p.styles_link__dnW4I {
    font-size: 1.8rem;
    line-height: 2.25rem; }
  .styles_linkContainer__YkRnF.styles_active__skmLq p.styles_link__dnW4I,
  .styles_linkContainer__YkRnF.styles_active__skmLq h2 {
    background-image: linear-gradient(90deg, #6ba5ff, #4682b4, #aa336a, #c41e3a);
    background-size: 180% 100%;
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    animation: styles_gradientText__6P4Oa 6s ease infinite;
    display: inline-block; }
`, "",{"version":3,"sources":["webpack://./src/modules/shelter/components/BoothScreen/Sidemenu/SidemenuLink/styles.module.scss"],"names":[],"mappings":"AAAA;EACE;IACE,2BAA2B,EAAA;EAE7B;IACE,6BAA6B,EAAA;EAE/B;IACE,2BAA2B,EAAA,EAAA;;AAI/B;EACI,UAAU;EACV,kBAAkB,EAAA;EAFtB;IAKM,iBAAiB;IACjB,oBAAoB,EAAA;EAN1B;;IAWU,4EAMC;IACD,0BAA0B;IAC1B,6BAA6B;IAC7B,qBAAqB;IACrB,kBAAkB;IAClB,sDAAwC;IACxC,qBAAqB,EAAA","sourcesContent":["@keyframes gradientText {\n  0% {\n    background-position: 0% 50%;\n  }\n  50% {\n    background-position: 100% 50%;\n  }\n  100% {\n    background-position: 0% 50%;\n  }\n}\n\n.linkContainer {\n    width: 75%;\n    margin-top: 0.5rem;\n\n    p.link {\n      font-size: 1.8rem;\n      line-height: 2.25rem;\n    }\n    &.active {\n        p.link,\n        h2 {\n          background-image: linear-gradient(\n            90deg,\n            #6ba5ff,\n            #4682b4,\n            #aa336a,\n            #c41e3a\n          );\n          background-size: 180% 100%;\n          -webkit-background-clip: text;\n          background-clip: text;\n          color: transparent;\n          animation: gradientText 6s ease infinite;\n          display: inline-block;\n        }\n      }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"linkContainer": `styles_linkContainer__YkRnF`,
	"link": `styles_link__dnW4I`,
	"active": `styles_active__skmLq`,
	"gradientText": `styles_gradientText__6P4Oa`
};
export default ___CSS_LOADER_EXPORT___;
